<template>
    <div>

        <about/>
        

    </div>
</template>

<script>
import About from './About.vue';

export default {
    components: {
        About,
    },
};
</script>

<style scoped>


p {
    text-align: justify;
}
h1 {
    font-size: 7vmin;
}
</style>
